import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-rating',
	templateUrl:'./WaRatingPage.html',
	styles: [],
	styleUrls:['./WaRatingPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaRatingPage
{
	mdContent_437 = `\`\`\`java
import com.jwebmp.webawesome.components.rating.WaRating;
\`\`\``;
	mdContent_438 = `\`\`\`java
var rating = new WaRating<>();
rating.setMax(5);
rating.setPrecision(0.5);
rating.setValue(3.5);
\`\`\``;
}
